var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-1,.cls-3{stroke-width:0px;}.cls-2{stroke:#b70d7f;stroke-width:2px;}.cls-4{isolation:isolate;}.cls-3{fill:#b70d7f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.68,17.41v.05h4.55v2.05h-7.38v-1.92l3.21-3.07c.65-.62,1.1-1.14,1.36-1.56.26-.42.39-.86.39-1.32,0-1.03-.55-1.55-1.66-1.55-.96,0-1.89.38-2.77,1.15v-2.17c.97-.63,2.07-.95,3.3-.95,1.15,0,2.04.29,2.68.86.64.58.96,1.35.96,2.33,0,1.31-.78,2.66-2.35,4.05l-2.3,2.05Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15,
    cy: 14.5,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 15,
    cy: 14.5,
    r: 11
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.117e218e7843c971bba6e9ab3d39cfc0.svg";
export { ForwardRef as ReactComponent };